import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import DoubleCounter from 'components/shared/counters/double/DoubleCounter';
import Emoji from 'components/shared/Emoji';
import routes from 'common/routes';

function TodaySessionsCounters() {
  const { t } = useTranslation(['sessions']);
  const navigate = useNavigate();

  const todayMorningSessionsCounter = useSelector((state) => state.session.counters.todayMorning);
  const todayAfternoonSessionsCounter = useSelector(
    (state) => state.session.counters.todayAfternoon
  );

  return (
    <DoubleCounter
      emoji={<Emoji label={t('sessionsToday', { ns: 'sessions' })} symbol="🕛" />}
      title={t('sessionsToday', { ns: 'sessions' })}
      onClick={() => navigate(routes.calendar.path)}
      counters={[
        {
          title: t('tomorrow', { ns: 'common' }),
          counter: todayMorningSessionsCounter
        },
        {
          title: t('afternoonNight', { ns: 'common' }),
          counter: todayAfternoonSessionsCounter
        }
      ]}
    />
  );
}

export default TodaySessionsCounters;
